"use client";

import Button from "@/components/flowbite/button/button";
import { ErrorPage } from "@/components/flowbite/error-page";
import { dictionaries } from "@/dictionaries/content";

interface RuntimeErrorFallbackProps {
  onRetry: () => void;
}

export function RuntimeErrorFallback({ onRetry }: RuntimeErrorFallbackProps) {
  return (
    <ErrorPage
      message={dictionaries.serverError.message}
      statusCode={dictionaries.serverError.statusCode}
      title={dictionaries.serverError.title}
    >
      <div className="flex flex-col items-stretch justify-center gap-3 pt-6 sm:flex-row sm:items-center">
        <Button onClick={onRetry}>{dictionaries.serverError.tryAgainBtn}</Button>
      </div>
    </ErrorPage>
  );
}
